





































































import { Component, Prop, Vue } from 'vue-property-decorator'
import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage } from '@/utils/common'
import { estiloInlineDirective } from './estilosInlineCsp'

// O corpo do e-mail renderizado usa tabela (bloco de assinatura), imagens (logo, inclusive
// data: URI do placeholder) e formatação inline — por isso a allowlist é mais ampla que o
// $sanitize padrão do projeto (pensado para texto simples), mas continua sem script/iframe/
// atributos de evento, então o risco de XSS do conteúdo vindo do editor fica coberto.
const SANITIZE_OPTIONS_PREVIA_EMAIL = {
  allowedTags: [
    'a', 'b', 'strong', 'i', 'em', 'u', 'p', 'br', 'div', 'span',
    'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'table', 'thead', 'tbody', 'tr', 'td', 'th', 'img',
  ],
  allowedAttributes: {
    a: ['href', 'target', 'style', 'class'],
    img: ['src', 'alt', 'width', 'height', 'style', 'class'],
    table: ['style', 'class', 'border', 'cellpadding', 'cellspacing'],
    td: ['style', 'class', 'valign', 'rowspan', 'colspan'],
    th: ['style', 'class', 'valign', 'rowspan', 'colspan'],
    '*': ['style', 'class'],
  },
  allowedSchemes: ['http', 'https', 'mailto'],
  allowedSchemesByTag: {
    img: ['http', 'https', 'data'],
  },
}

@Component({
  directives: { estiloInline: estiloInlineDirective },
})
export default class PreviewNotificacaoEmail extends Vue {
  @Prop({ required: true }) tipo: string
  @Prop({ default: '' }) assunto: string
  @Prop({ default: '' }) emailCorpo: string
  @Prop({ default: '' }) emailRodape: string

  show: boolean = false
  carregando: boolean = false
  showModalEnviarTeste: boolean = false
  loadingEnviarTeste: boolean = false
  emailTeste: string = ''
  html: string | null = null
  erro: string | null = null
  sanitizeOptions = SANITIZE_OPTIONS_PREVIA_EMAIL

  async abrir() {
    this.show = true
    this.carregando = true
    this.html = null
    this.erro = null

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.gerarPreviewNotificacaoEmail({
      tipo: this.tipo,
      emailCorpo: this.emailCorpo,
      emailRodape: this.emailRodape,
    })

    this.carregando = false

    if (response.success) {
      this.html = response.data || ''
    } else {
      this.erro = response.message || null
    }
  }

  private scrollLockObserver: MutationObserver | null = null

  mounted() {
    // Vuetify 1.x remove a trava de scroll do <html> ao fechar QUALQUER v-dialog, mesmo com
    // outro ainda aberto por cima (bug de pilha de overlays) — isso deixa a página com dois
    // scrolls visíveis (o da página e o do diálogo de edição) até fechar tudo. Reaplica a trava
    // sempre que ela sumir enquanto ainda existir um diálogo ativo na página.
    this.scrollLockObserver = new MutationObserver(() => {
      const travado = document.documentElement.classList.contains('overflow-y-hidden')
      const existeDialogoAtivo = !!document.querySelector('.v-dialog--active')

      if (!travado && existeDialogoAtivo) {
        document.documentElement.classList.add('overflow-y-hidden')
      }
    })

    this.scrollLockObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
  }

  beforeDestroy() {
    this.scrollLockObserver?.disconnect()
  }

  abrirModalEnviarTeste() {
    this.emailTeste = this.$user.profile.email
    this.showModalEnviarTeste = true
  }

  async enviarTeste() {
    this.loadingEnviarTeste = true

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.enviarNotificacaoEmailTeste({
      tipo: this.tipo,
      assunto: this.assunto,
      emailCorpo: this.emailCorpo,
      emailRodape: this.emailRodape,
      emailDestino: this.emailTeste,
    })

    this.loadingEnviarTeste = false

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao enviar o e-mail de teste.', 'error'))
      return
    }

    EventBus.$emit('setSnackbar', getSnackbarMessage(`E-mail de teste enviado para ${this.emailTeste}.`, 'success'))
    this.showModalEnviarTeste = false
  }
}
